import {useCallback, useEffect, useMemo, useRef, useState} from 'react';

import {
	ESharedEvents,
	useSharedEvent,
} from '@src/Components/SharedEventProvider';
import celebrationVideo from 'url:../../public/assets/celebration.mp4';
import loopVideo from 'url:../../public/assets/loop.mp4';

import * as classes from './Video.module.scss';

// This has to match the one in .celebrationVideo[transition] in Video.module.scss
const transitionDuration = 0.5;

function Video() {
	const {subscribe} = useSharedEvent();

	const [isCelebrationVisible, setIsCelebrationVisible] = useState(false);
	const celebrationVideoRef = useRef<HTMLVideoElement | null>(null);

	useEffect(() => {
		subscribe(ESharedEvents.QuizWinEvent, () => {
			if (celebrationVideoRef.current) {
				celebrationVideoRef.current.currentTime = 0;
				celebrationVideoRef.current
					.play()
					.catch((videoError: unknown) => {
						console.error(videoError as Error);
					});

				setIsCelebrationVisible(true);
			} else {
				console.error('Celebration Video not loaded yet');
			}
		});
	}, [subscribe]);

	const handleTimeUpdate = useCallback(
		(e: React.SyntheticEvent<HTMLVideoElement>) => {
			const videoElement = e.currentTarget;
			if (
				videoElement.duration - videoElement.currentTime <=
				transitionDuration
			) {
				setIsCelebrationVisible(false);
			}
		},
		[]
	);

	const celebrationVideoClasses = useMemo(() => {
		return [
			classes.celebrationVideo,
			isCelebrationVisible ? classes.celebrationVideoVisible : undefined,
		].join(' ');
	}, [isCelebrationVisible]);

	return (
		<div className={classes.videoContainer}>
			<video src={loopVideo} loop muted autoPlay />
			<video
				src={celebrationVideo}
				className={celebrationVideoClasses}
				muted
				ref={celebrationVideoRef}
				onTimeUpdate={handleTimeUpdate}
				onEnded={() => {
					setIsCelebrationVisible(false);
				}}
			/>
		</div>
	);
}

export default Video;
